<template>
  <div class="containter-custom">
    <div class="md-layout md-alignment-center-center vh100 m-tb-minus-40">
    <div class="auth_logo pt-60 mt-20 mb--10"><img class="auth_logo" :src="logoNew" /></div>
    <md-card class="mt-minus-25 md-layout-item md-size-40 md-small-size-100 bg_w rounded pt-40 pb-60 pl-30 pr-30">
      <md-card-header class="pt-0">
        <h3 class="center bold mb-0">Passwort vergessen</h3>
      </md-card-header>

      <md-card-content class="pt-30">
        <div id="signIn_wrapper" class="auth_wrapper">
          <div class="relative" id="signUp_content">
            <p class="center">
              Bitte geben Sie Ihre E-Mail-Adresse ein.<br>
              Wenn Ihr Konto existiert, erhalten Sie umgehend einen Link zum Zurücksetzen Ihres Passworts.
            </p>
            <br>
            <br>
              <div id="first_slide">
                <div class="relative">
                  <md-field class="md-focused">
                    <label for="username" class="input_helper">Email<span class="md-required">*</span></label>
                    <md-input type="email" @keyup.enter="SendNewPwMail" id="username" v-model="username" placeholder="Email-Adresse" class="auth_input" />
                  </md-field>
                </div>

                <p class="alert center" v-if="msg">{{ msg }}</p>
              </div>
          </div>
        </div>
      </md-card-content>

      <md-card-actions class="justify-center pb-20">
        <md-button id="pre_signIn_button" class="md-raised md-primary" type="button"
                   @click="SendNewPwMail" value="Send email">Absenden
        </md-button>
      </md-card-actions>
    </md-card>

    </div>
  </div>
</template>

<script>
import AuthService from "../../services/AuthService";

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
  },
  data() {
    return {
      msg: '',
      username: '',
      logoNew: null,
      logoBack: null,
    };
  },
  created() {
  },
  async mounted() {
    let self = this;
    await this.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.logoNew = result.baseLogo;
        self.logoBack = process.env.VUE_APP_CRM_URL + "/titleImgs/file." + result.logoback
        document.getElementsByClassName("containter-custom")[0].style.cssText = `background-image: url(${self.logoBack})`;
      }
    });
    const input = document.querySelector('input');
    input.classList.contains('auth_input') ? input.focus() : '';
  },
  methods: {
    async SendNewPwMail() {
      let self = this;
      this.msg = "";
      const credentials = {
        username: this.username,
      };
      const res = await AuthService.newPw({data: this.encodeData(credentials)});
      if (res.status === "ok") {
        Object.assign(self.options.globalConfirm, {
          visible: true,
          title: 'E-Mail gesendet',
          message: 'Wir haben Ihnen soeben eine E-Mail zum Zurücksetzen Ihres Passworts geschickt. Bitte prüfen Sie Ihren Posteingang.',
          hideCancel: true,
          confirmBtnText: 'Schließen',
          confirmBtnClass: 'md-raised md-primary',
          onConfirm: () => {
            self.options.globalConfirm.visible = false;
            self.$router.push('/signin');
          },
          onCancel: () => {
            self.options.globalConfirm.visible = false;
            self.$router.push('/signin');
          }
        });
      } else if (res.msg === "api_pw_mail_rejected") {
        Object.assign(self.options.globalConfirm, {
          visible: true,
          title: 'E-Mail konnte nicht zugestellt werden',
          message: 'Ihre E-Mail-Adresse wurde vom Mailserver abgelehnt, daher konnte die E-Mail zum Zurücksetzen des Passworts nicht versendet werden. Bitte kontaktieren Sie den Support, um Ihre E-Mail-Adresse zu überprüfen.',
          hideCancel: true,
          confirmBtnText: 'Schließen',
          confirmBtnClass: 'md-raised md-primary',
          onConfirm: () => {
            self.options.globalConfirm.visible = false;
          },
          onCancel: () => {
            self.options.globalConfirm.visible = false;
          }
        });
      } else if (res.msg === "api_username_not_exist") {
        this.msg = "Der Benutzername existiert nicht.";
      } else {
        this.msg = "Fehler beim Versenden der E-Mail. Bitte versuchen Sie es später erneut.";
      }
    },
  }
};
</script>
<style>
img.auth_logo{
  max-width: 200px !important;
  max-height: 200px !important;
  padding-bottom: 20px;
  margin: auto;
}

.containter-custom{
  width: 100%;
  min-height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>